import {IFaceMatchSource, IFaceMatchValidation, ValidationType} from '@core/api/data-access';

import {ValidationModel} from '../validation.abstract.model';

// FaceMatch
export class FaceMatchValidationModel extends ValidationModel implements IFaceMatchValidation {
	public ordinal = NaN;
	public readonly type = ValidationType.FaceMatch;
	originalInstance: IFaceMatchValidation;
	/**
	 * ExactlyOne<{metaData: number, documentVerification: boolean}>	- means that exactly one of the fields must be filled
	 */
	imageToCompare: IFaceMatchSource = null;

	// For metaData fields that include the base64 image to compare:
	imageData?: string | null = null;

	constructor(initWith: IFaceMatchSource = null) {
		super();
		this.imageToCompare = initWith;
	}

	override asFaceMatch(): FaceMatchValidationModel {
		return this;
	}

	isValid(): boolean {
		return !isNaN(this.ordinal) && Boolean(this.imageToCompare) && (this.imageToCompare?.documentVerification || !isNaN(this.imageToCompare?.metaData));
	}

	toJSON(): IFaceMatchValidation {
		return {
			ordinal: this.ordinal,
			type: ValidationType.FaceMatch,
			imageToCompare: this.imageToCompare,
		};
	}

	toObject(): IFaceMatchValidation {
		return {
			...this.toJSON(),
			imageData: this.imageData,
		};
	}
}
